import { Box, Stack, styled, SxProps, Theme, Typography } from '@mui/material';

export const LegendRoot = styled(Box, { name: 'PolicyLegend' })(({ theme }) => ({
  flexShrink: 0,
  margin: '0 0.5rem 0.5rem',
  padding: '0.625rem 0.75rem',
  border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: '0.625rem',
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerLow,
}));

export const SeverityRow = styled(Stack, { name: 'PolicyLegendSeverityRow' })(({ theme }) => ({
  alignItems: 'flex-start',
  gap: '0.4375rem',
  marginBottom: '0.25rem',
  fontSize: '0.6875rem',
  lineHeight: 1.45,
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
}));

export const LegendNote = styled(Typography, { name: 'PolicyLegendNote' })(({ theme }) => ({
  margin: '0.5rem 0 0',
  fontSize: '0.6875rem',
  lineHeight: 1.45,
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
}));

// Typography carries these rather than styled(): the polymorphic `component` prop
// these two need loses its typing once the component is wrapped in styled()
export const legendHeadingSx: SxProps<Theme> = {
  display: 'block',
  marginBottom: '0.375rem',
  fontSize: '0.625rem',
  fontWeight: 700,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};

export const severityNameSx: SxProps<Theme> = {
  fontSize: 'inherit',
  lineHeight: 'inherit',
  fontWeight: 600,
  color: (theme) => theme.palette.custom.OV.sys.onBackground,
};
